var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowTopGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0782 7.72201L8.82816 0.759204C8.70928 0.632424 8.5691 0.533044 8.41566 0.466766C8.11133 0.327484 7.76999 0.327484 7.46566 0.466766C7.31222 0.533044 7.17204 0.632424 7.05316 0.759204L0.803162 7.72201C0.686613 7.85185 0.594163 8.006 0.531087 8.17564C0.468012 8.34529 0.435547 8.52711 0.435547 8.71073C0.435547 9.08157 0.567782 9.43723 0.803162 9.69945C1.03854 9.96168 1.35778 10.109 1.69066 10.109C2.02354 10.109 2.34278 9.96168 2.57816 9.69945L6.69066 5.104V15.6735C6.69066 16.0429 6.82236 16.3971 7.05678 16.6582C7.2912 16.9194 7.60914 17.0661 7.94066 17.0661C8.27218 17.0661 8.59012 16.9194 8.82454 16.6582C9.05897 16.3971 9.19066 16.0429 9.19066 15.6735V5.104L13.3032 9.69945C13.4194 9.82998 13.5576 9.93357 13.7099 10.0043C13.8623 10.075 14.0256 10.1114 14.1907 10.1114C14.3557 10.1114 14.5191 10.075 14.6714 10.0043C14.8237 9.93357 14.962 9.82998 15.0782 9.69945C15.1953 9.57 15.2883 9.41598 15.3518 9.24628C15.4152 9.07658 15.4479 8.89457 15.4479 8.71073C15.4479 8.5269 15.4152 8.34488 15.3518 8.17519C15.2883 8.00549 15.1953 7.85147 15.0782 7.72201Z",
    fill: "#55B4BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowTopGreen);
export default __webpack_public_path__ + "static/media/icon-arrow-top-green.af242eabc3e72d79df56a070a2f8de21.svg";
export { ForwardRef as ReactComponent };